import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../Common/Layout";
import UserList from "./UserList";

const CreateUser = () => {
  const [formData, setFormData] = useState({
    emp_id: "",
    name: "",
    email: "",
    password: "",
    role: "",
    warehouse_location: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.emp_id) tempErrors.emp_id = "Employee ID is required";
    if (!formData.name) tempErrors.name = "Name is required";
    if (!formData.email) tempErrors.email = "Email is required";
    if (!formData.password) tempErrors.password = "Password is required";
    if (!formData.role) tempErrors.role = "Role is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized! Please login again.");
      return;
    }

    try {
      const response = await fetch(
        "https://irc.zentelex.com/api/users/create-user",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData), // ✅ emp_id & warehouse_location included
        },
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("User created successfully!");
        setFormData({
          emp_id: "",
          name: "",
          email: "",
          password: "",
          role: "",
        });
      } else {
        toast.error(data.message || "Failed to create user");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  return (
    <Layout>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-12 text-center">
                <br />
                <h4 className="page-title">Create New User</h4>
                <p className="text-muted">Add system user & assign role</p>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-7 col-md-9 col-sm-11">
                <div className="card rounded-3 shadow-sm border-0">
                  <div
                    className="p-4 text-white text-center"
                    style={{
                      backgroundColor: "#0F71AD",
                      color: "white",
                    }}
                  >
                    <h5 className="mb-0">Create User</h5>
                  </div>

                  <div
                    className="card-body p-4"
                    style={{
                      backgroundColor: "#0F71AD",
                      color: "white",
                    }}
                  >
                    <form onSubmit={handleSubmit}>
                      {/* Employee ID */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Employee ID <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="emp_id"
                          value={formData.emp_id}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.emp_id ? "is-invalid" : ""
                          }`}
                          placeholder="EMP-001"
                        />
                        {errors.emp_id && (
                          <div className="invalid-feedback">
                            {errors.emp_id}
                          </div>
                        )}
                      </div>

                      {/* Name */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Full Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                          placeholder="Enter full name"
                        />
                        {errors.name && (
                          <div className="invalid-feedback">{errors.name}</div>
                        )}
                      </div>

                      {/* Email */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Email Address <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="example@company.com"
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>

                      {/* Password */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Password <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.password ? "is-invalid" : ""
                          }`}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      {/* Role */}
                      <div className="mb-4">
                        <label className="form-label fw-semibold">
                          User Role <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="role"
                          value={formData.role}
                          onChange={handleChange}
                          className={`form-select ${
                            errors.role ? "is-invalid" : ""
                          }`}
                        >
                          <option value="">Select role</option>
                          <option value="Operations">Operations</option>
                          <option value="QC">Quality Control</option>
                          <option value="Accounts">Accounts</option>
                        </select>
                        {errors.role && (
                          <div className="invalid-feedback">{errors.role}</div>
                        )}
                      </div>

                      <button
                        type="submit"
                        className="btn w-100 fw-semibold"
                        style={{
                          backgroundColor: "#EC662C",
                          color: "white",
                        }}
                      >
                        Create User
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <UserList></UserList>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </Layout>
  );
};

export default CreateUser;
